import angular from 'angular';
import { runnerSetupDeleteSearchBridge } from './RunnerSetupDeleteSearchBridge';

/**
 * @ngdoc directive
 * @name runnerSetupDeleteWarnings
 * @module flowingly.runner.setup
 * @description  This component is used to search through entities (to choose one to replace entity being deleted)
 * @usage
 * ```
     
 * ``` 
 * ### Notes
 *
 * 
 * ### Properties
 * #### Inputs
 */
(function () {
  'use strict';

  angular
    .module('flowingly.runner.setup')
    .component('runnerSetupDeleteSearch', runnerSetupDeleteSearchBridge);
})();
